import {PropertyFilter} from './propertyFilter';

export abstract class SingleValuePropertyFilter extends PropertyFilter {
  queryValue: any;
}
